import React, { Component } from 'react'
import { Button } from 'antd'
import { api } from '../../../../services'
import FileSaver from 'file-saver'
import moment from 'moment'

class ExportUsersButton extends Component {
  state = {
    isFetching: false
  }

  onClick = () => {
    const { user } = this.props

    this.setState({
      isFetching: true
    })

    api.user.exportUsers()
      .then(response => {
        const blob = new Blob([response.data], {
          type: 'text/csv'
        })

        FileSaver.saveAs(blob, user.info.organization.name + '-users-' + moment().format('MM-DD-YYYY') + '.csv')

        this.setState({
          isFetching: false
        })
      })
      .catch(() => {
        this.setState({
          isFetching: false
        })
      })
  }

  render () {
    const { isFetching } = this.state
    const { children } = this.props
    return (
      <Button
        onClick={this.onClick}
        icon='download'
        loading={isFetching}
        disabled={isFetching}
      >{ children }</Button>
    )
  }
}

export default ExportUsersButton



// WEBPACK FOOTER //
// ./src/views/Users/components/ExportUsersButton/ExportUsersButton.jsx